import { ReactElement } from 'react'
import styled from 'styled-components'
import { breakpoints } from '../../../../../../src/theme/breakpoints'
import { ArrowForward, ThreeSixty } from '@mui/icons-material'
import { Slide } from '../../../../../../src/store/models/SearchModels'
import { IMAGE_360_SLIDE } from './carousel/Contstants'
import { I18n } from 'common'
import { Button } from '../../../../../../src/ui-components/forms/ButtonV2'

interface Props {
  onClick: (slide: Slide) => void
}

const ViewIn360Button = (props: Props): ReactElement => {
  const { onClick } = props

  const handleClick = () => {
    onClick(IMAGE_360_SLIDE)
  }

  return (
    <Image360ButtonWrapper>
      <StyledButton variant="secondary" onClick={handleClick}>
        <Center>
          <ThreeSixty />
          <Flex style={{ gap: '4px' }}>
            <I18n name="viewIn360" />
            <ArrowForward />
          </Flex>
        </Center>
      </StyledButton>
    </Image360ButtonWrapper>
  )
}

const Image360ButtonWrapper = styled.div`
  margin: 0px 25px;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 100%;
  }
`

const StyledButton = styled(Button)`
  width: 100%;
  margin: 0px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  text-transform: none;
`

const Flex = styled.div`
  display: flex;
`

const Center = styled(Flex)`
  justify-content: center;
  gap: 12px;
`

export default ViewIn360Button
